import { NativeModules, NativeEventEmitter } from 'react-native';
import type {
  JYWhiteBoardInitOptions,
  Listener,
  JYWhiteBoardJoinRoomOptions,
} from './Types';
import type { JoinRoomEvent } from './JYWhiteBoardEvents';

const { JYWhiteBoardModule } = NativeModules;

const JYWhiteBoardEvent = new NativeEventEmitter(JYWhiteBoardModule);

let whiteBoardManager: JYWhiteBoardManager | undefined;

export default class JYWhiteBoardManager {
  private _listeners = new Map<string, Listener>();

  static instance(): JYWhiteBoardManager {
    if (whiteBoardManager) {
      return whiteBoardManager as JYWhiteBoardManager;
    } else {
      throw new Error('please create RtcEngine first');
    }
  }
  static async init(
    options: JYWhiteBoardInitOptions
  ): Promise<JYWhiteBoardManager> {
    if (whiteBoardManager) return whiteBoardManager;
    await JYWhiteBoardModule.init(options);
    whiteBoardManager = new JYWhiteBoardManager();
    return whiteBoardManager;
  }

  joinRoom(options: JYWhiteBoardJoinRoomOptions): Promise<void> {
    let res = JYWhiteBoardModule.joinRoom(options);
    return res;
  }

  destroy() {
    this.removeAllListener();
    whiteBoardManager = undefined;
    return JYWhiteBoardModule.destroy();
  }
  addListener<EventType extends keyof JoinRoomEvent>(
    event: EventType,
    listener: JoinRoomEvent[EventType]
  ) {
    console.log('begin add Listener' + event);
    if (!this._listeners.has(event)) {
      this._listeners.set(event, listener);
      console.log('end add Listener');
      JYWhiteBoardEvent.addListener(event, listener);
    }
  }
  removeListener<EventType extends keyof JoinRoomEvent>(
    event: EventType,
    listener: JoinRoomEvent[EventType]
  ) {
    if (this._listeners.has(event)) {
      this._listeners.delete(event);
      JYWhiteBoardEvent.removeListener(event, listener);
    }
  }
  removeAllListener() {
    this._listeners.forEach((value, key) => {
      this._listeners.delete(key);
      JYWhiteBoardEvent.removeListener(key, value);
    });
    this._listeners.clear();
  }
}
